import { useState, useEffect } from 'react';
import { Header3, BodyText } from 'components/UI/Brand/text';
import CustomImage from 'components/UI/CustomImage/CustomImage';
import { IGeneralSection } from 'interfaces/IMarketing';
import ArrowSearchLink from 'components/UI/Links/ArrowSearchLink';
import ContentfulRenderer from 'components/ContentfulRenderer';
import { AlertBox, LinkText } from 'components';
import { ImageCroppings } from './ImageCroppings';
import { HEADER_SIZE } from './utils/getHeader.util';
import styles from './styles.module.scss';

interface IRightSectionAProps {
  article: IGeneralSection;
  highestHeadingSize?: HEADER_SIZE;
}

const RightSectionA = ({
  article,
  highestHeadingSize = HEADER_SIZE.H1,
}: IRightSectionAProps) => {
  const { title, link, media, croppingSize } = article;
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);

  useEffect(() => {
    switch (croppingSize) {
      case ImageCroppings.Tall:
        setImageWidth(272);
        setImageHeight(482);
        break;
      case ImageCroppings.Square:
        setImageWidth(400);
        setImageHeight(400);
        break;
      default:
        setImageWidth(544);
        setImageHeight(306);
    }
  }, []);

  return (
    <div className={styles.rightSectionA} id={article.title}>
      <div className={styles.textContainer}>
        <Header3 className={styles.title}>{title}</Header3>
        <ContentfulRenderer
          highestHeadingSize={HEADER_SIZE.H4}
          highestDOMHeadingSize={HEADER_SIZE.H4}
        >
          {article.longDescription}
        </ContentfulRenderer>

        {article.infoBox && (
          <AlertBox type="info" OverrideIcon=" " className={styles.infoBox}>
            <ContentfulRenderer highestHeadingSize={highestHeadingSize}>
              {article.infoBox}
            </ContentfulRenderer>
          </AlertBox>
        )}
        {link && (
          <div className={styles.linkContainer}>
            {(link.type === 'hyperlink' ||
              link.type === 'articleContainerLink') &&
              link.link && (
                <LinkText
                  href={link.type === 'hyperlink' ? link.hyperlink : link.link}
                >
                  {article.link.title}
                </LinkText>
              )}
            {link.type === 'search criteria' && (
              <div className={styles.linkContainer}>
                <ArrowSearchLink link={article.link} />
                <BodyText>{link.description}</BodyText>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles.imageContainer}>
        {media && (
          <CustomImage
            className={styles.image}
            src={article.media || ''}
            alt={article.title}
            width={imageWidth}
            height={imageHeight}
          />
        )}
      </div>
    </div>
  );
};

export default RightSectionA;
